export const iconFontAwesomeMedicalHealthSkull = (
	<i className="fa-solid fa-skull"></i>
);
